import { Component, Input, OnInit } from '@angular/core';
import { NavController, ModalController, PopoverController, MenuController } from '@ionic/angular';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AuthGuard } from 'src/app/providers/auth-guard';
import { AuthService } from 'src/app/providers/auth.service';
import { AjaxService } from 'src/app/providers/ajax.service';
import { IonicService } from 'src/app/providers/ionic.service';
import { GlobalService } from 'src/app/providers/global.service';

@Component({
    selector: 'app-profilepopover',
    templateUrl: './profilepopover.page.html',
    styleUrls: ['./profilepopover.page.scss'],
})
export class ProfilePopoverPage implements OnInit
{
    @Input() value: any;
    public image: any;
    error: string;
    isSignup: false;
    isLogin: true;
    isForgot: false;
    email = "";
    gs = GlobalService;
    forgotOption: false;

    constructor(
        private nav: NavController,
        private modalCtrl: ModalController,
        private sanitizer: DomSanitizer,
        private Router: Router, public popoverController: PopoverController,private authService: AuthService, private ajaxService: AjaxService, private authGuard: AuthGuard, private menu: MenuController, private router: Router, private ionicService: IonicService
    ) { }

    ngOnInit()
    {
    
    }

    redirect(rURL)
    {
        this.popoverController.dismiss();
        this.router.navigate([rURL]);
    }
    logout(rURL)
    {
        this.authService.logout();
    }
   
    SignUp() {
        if (this.email == "")
            this.error = "Please enter email id";
        else {
            this.error = ""
            this.ajaxService.callGetService('signup/save?email=' + this.email, true).pipe().subscribe(res => {
                if (res == 2)
                    this.error = "Please ensure that your email address is in a valid format, such as user@example.com";
                else if (res == 0) {
                    this.error = "An error occurred. Please use a different email address.";
                    // this.forgotOption = true;
                }
                else if (res == 1) {
                    alert("Password sent to email");
                }
                //this.ionicService.showToast("Password sent to email");
            }, err => {
                this.ionicService.showErrorToast(err);
            });
        }
    }
}
